module.exports = __webpack_public_path__ + "static/img/img_gyc_c.a8c9aebb.png";